import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import i18next from "i18next";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";

const t = i18next.getFixedT();

const _urlPrefix = "/notify";

export const fetchNotificationPaging = createAsyncThunk(
    "notify/fetchNotificationPaging",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/page`,
            params: AppUtil.toSnakeCaseKey(params),
            method: "GET"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceUpdateNotifications = createAsyncThunk(
    "notify/reduceUpdateNotifications",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/updates`,
            data: AppUtil.toSnakeCaseKey(params),
            method: "PUT"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

const initialState = {
    list: [],
    count: 0
};

const slice = createSlice({
    name: "notification",
    initialState: initialState,
    reducers: {
        addNotificationCount: (state, {payload}) => {
            state.count = state.count+1;
        }
    },
    extraReducers: {
        [fetchNotificationPaging.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.list = payload.notifications;
                state.count = payload.totalNotSeen;
            }
        }
    },
});

const { reducer, actions } = slice;
export const {addNotificationCount} = actions;
export default reducer;

export const getNotificationList = createSelector(
    state => state.notification.list,
    list => list
)

export const getNotificationCount = createSelector(
    state => state.notification.count,
    list => list
)
